import { render, staticRenderFns } from "./SıteItem.vue?vue&type=template&id=5d582030&scoped=true&"
import script from "./SıteItem.vue?vue&type=script&lang=js&"
export * from "./SıteItem.vue?vue&type=script&lang=js&"
import style0 from "./SıteItem.vue?vue&type=style&index=0&id=5d582030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d582030",
  null
  
)

export default component.exports